import styled, { css } from 'styled-components';

import { Divider } from '@belong/ui-components';
import { ISpacingProps } from '@belong/types';
import { media, mediaMap } from '@belong/themes';

const CONTENT_MARGIN = { xs: '2.4rem', md: '3.2rem' };

export const MobileOnlyDivider = styled(Divider)<ISpacingProps>`
  // re-apply margins in order to override default divider margin
  ${mediaMap(
    CONTENT_MARGIN,
    margin => css`
      margin: ${margin} 0 ${margin};
    `
  )}

  ${media('lg')`
    display: none;
  `}
`;
